import api, { formDataInstance } from "./baseRequest";

export const aboutImagesService = {
  getAllAboutImages: (pageOptions = {}) => {
    const params = new URLSearchParams();
    if (pageOptions.page) params.append("page", pageOptions.page);
    if (pageOptions.limit) params.append("limit", pageOptions.limit);
    if (pageOptions.sortBy) params.append("sortBy", pageOptions.sortBy);
    if (pageOptions.sortOrder)
      params.append("sortOrder", pageOptions.sortOrder);

    return api.get(`/about-images?${params.toString()}`);
  },

  getAboutImageById: (id) => {
    return api.get(`/about-images/${id}`);
  },

  createAboutImage: (imageData) => {
    const formData = new FormData();
    if (imageData.image) {
      formData.append("image", imageData.image);
    }

    return formDataInstance.post("/admin/about-images", formData);
  },

  updateAboutImage: (id, imageData) => {
    const formData = new FormData();
    if (imageData.image) {
      formData.append("image", imageData.image);
    }

    return formDataInstance.put(`/admin/about-images/${id}`, formData);
  },

  deleteAboutImage: (id) => {
    return api.delete(`/admin/about-images/${id}`);
  },

  reorderAboutImages: (aboutImageIds) => {
    return api.patch("/admin/about-images/reorder", { aboutImageIds });
  },
};
